const el = {
  root: document.querySelector<HTMLButtonElement>('.login-page'),
  navigationButtons: document.querySelectorAll<HTMLButtonElement>('.login-page__navigation-button'),
  forms: document.querySelectorAll<HTMLElement>('.login-page__form'),
}

export const LoginPage = {
  init(): void {
    if (!el.root) return

    el.navigationButtons.forEach((button) => {
      button.addEventListener('click', this.switchTab)
    })

    el.forms.forEach((form) => {
      form.addEventListener('submit', this.submitForm)
    })
  },

  switchTab(event): void {
    el.navigationButtons.forEach((button) => {
      button.classList.remove('login-page__navigation-button--active')
      button.setAttribute('aria-selected', 'false')
    })

    el.forms.forEach((form) => {
      form.classList.remove('login-page__form--active')
      form.querySelector('.login-page__security-number').classList.remove('login-page__security-number--active')
    })

    event.target.classList.add('login-page__navigation-button--active')
    event.target.setAttribute('aria-selected', 'true')
    document.querySelector<HTMLElement>(`#${event.target.getAttribute('aria-controls')}`).classList.add('login-page__form--active')
  },

  submitForm(event): void {
    event.preventDefault()

    // TODO

    event.target.querySelector('.login-page__security-number').classList.add('login-page__security-number--active')
    event.target.querySelector('.login-page__security-number span').textContent = Math.floor(1000 + Math.random() * 9000)
  },
}
